/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_9_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our services are not directed to individuals under the age of 16. We do not knowingly collect personal information from children. If you become aware that a child has provided us with personal data, please contact us and we will take steps to remove such information.`)
};

const es_privacy_section_9_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestros servicios no están dirigidos a personas menores de 16 años. No recopilamos intencionalmente información personal de niños. Si descubres que un menor nos ha proporcionado datos personales, contáctanos y tomaremos medidas para eliminar dicha información.`)
};

const de_privacy_section_9_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Dienste richten sich nicht an Personen unter 16 Jahren. Wir erfassen wissentlich keine persönlichen Daten von Kindern. Wenn Sie erfahren, dass ein Kind uns persönliche Daten zur Verfügung gestellt hat, kontaktieren Sie uns bitte und wir werden Maßnahmen ergreifen, um diese Informationen zu entfernen.`)
};

const nl_privacy_section_9_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onze diensten zijn niet gericht op personen jonger dan 16 jaar. We verzamelen niet bewust persoonlijke informatie van kinderen. Als u ontdekt dat een kind ons persoonlijke gegevens heeft verstrekt, neem dan contact met ons op en we zullen stappen ondernemen om dergelijke informatie te verwijderen.`)
};

const fr_privacy_section_9_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nos services ne s’adressent pas aux personnes de moins de 16 ans. Nous ne collectons pas sciemment d’informations personnelles auprès d’enfants. Si vous apprenez qu’un enfant nous a fourni des données personnelles, veuillez nous contacter et nous prendrons des mesures pour supprimer ces informations.`)
};

const it_privacy_section_9_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I nostri servizi non sono destinati a persone di età inferiore ai 16 anni. Non raccogliamo consapevolmente informazioni personali da minori. Se vieni a conoscenza che un minore ci ha fornito dati personali, contattaci e adotteremo le misure necessarie per rimuovere tali informazioni.`)
};

const pt_br2_privacy_section_9_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nossos serviços não são direcionados a indivíduos menores de 16 anos. Não coletamos intencionalmente informações pessoais de crianças. Se você souber que uma criança nos forneceu dados pessoais, entre em contato conosco e tomaremos medidas para remover tais informações.`)
};

const pt_privacy_section_9_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os nossos serviços não se destinam a indivíduos com menos de 16 anos. Não recolhemos intencionalmente informações pessoais de crianças. Se tomar conhecimento de que uma criança nos forneceu dados pessoais, contacte-nos e tomaremos medidas para remover essa informação.`)
};

const ja_privacy_section_9_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当サービスは16歳未満の個人を対象としていません。子供から意図的に個人情報を収集することはありません。子供が個人データを提供したことを知った場合は、ご連絡ください。該当情報の削除措置を講じます。`)
};

const zh_privacy_section_9_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们的服务不面向16岁以下的个人。我们不会故意收集儿童的个人信息。如果您发现儿童向我们提供了个人数据，请联系我们，我们将采取措施删除此类信息。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_9_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_9_text(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_9_text", locale)
	if (locale === "en") return en_privacy_section_9_text(inputs)
	if (locale === "es") return es_privacy_section_9_text(inputs)
	if (locale === "de") return de_privacy_section_9_text(inputs)
	if (locale === "nl") return nl_privacy_section_9_text(inputs)
	if (locale === "fr") return fr_privacy_section_9_text(inputs)
	if (locale === "it") return it_privacy_section_9_text(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_9_text(inputs)
	if (locale === "pt") return pt_privacy_section_9_text(inputs)
	if (locale === "ja") return ja_privacy_section_9_text(inputs)
	return zh_privacy_section_9_text(inputs)
};